import { useEffect } from 'react';

const BASE_TITLE = 'CloudAyn';

export const useDocumentTitle = (title: string, suffix: boolean = true) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = suffix ? `${title} | ${BASE_TITLE}` : title;

    return () => {
      document.title = previousTitle;
    };
  }, [title, suffix]);
};

export default useDocumentTitle;
